import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

import MenuItem from './MenuItem';
import {activateMenuItem} from './actions.js';


const Menu = ({...props}, {store}) => {
    const {
        activePath,
        icon,
        items,
        level,
        path = [],
        text,
        style = () => {},
    } = props;
    let {
        events = {
            onClick: (event, path) => {
                if (path) {
                    event.stopPropagation();
                    store.dispatch(activateMenuItem(path, props.elementId));
                }
            },
        },
    } = props;
    events = _.mapValues(events, eventHandler => event => eventHandler(event, props.path));
    return <span {...events}>
        {icon
            ? <i style={style('MenuIcon', props)} className={icon}></i>
            : null
        }
        <span style={style('MenuText', props)}>
            {text}
        </span>
        <ul style={style('Menu', props)}>
            {_.map(items, (item, index) => <MenuItem
                key={index}
                {...(_.pickBy(props, (value, key) => key !== 'icon'))}
                {...item}
                items={item.items}
                active={activePath.length > 0 && activePath[0] === index}
                activePath={activePath.length > 0 && activePath[0] === index ? activePath.slice(1) : []}
                path={[...path, index]}
                level={(level || 0) + 1}
                index={index}
                all={items}
            />)}
        </ul>
    </span>;
};
Menu.propTypes = {
    activePath: PropTypes.arrayOf(PropTypes.number).isRequired,
    active: PropTypes.bool,
    text: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.object).isRequired,
    style: PropTypes.func,
    path: PropTypes.arrayOf(PropTypes.number).isRequired,
};
Menu.contextTypes = {
    store: PropTypes.object,
};
export default Menu;
